module.exports = __webpack_public_path__ + "img/thumbnail_RedNeckedWallaby_m_albino.672cdc50.png";